import wrappedFetch from './base';

export const generateToken = () => {
  return wrappedFetch('/external_signal/create')
    .then((response) => response.json());
};

export const triggerExternalSignalManually = (token, jobId) => {
  return wrappedFetch(`/external_signal/manual_trigger/job/${jobId}/${token}`, {
    method: 'GET'
  })
    .then((response) => response.json());
};
